type ReducerHandler<S, A> = {
  [actionType: string]: (state: S, action: A) => S;
};

interface IAction {
  type: string;
  [key: string]: any;
}

function createReducer<State, Action extends IAction>(
  handlers: ReducerHandler<State, Action>,
  initialState: State = Object.create({})
) {
  return (state: State = initialState, action: Action) => {
    let newState;
    if (handlers[action.type]) {
      newState = handlers[action.type](state, action);
    }
    if (newState) {
      return newState;
    }
    return state;
  };
}

export default createReducer;
